import { render } from "./MetodoFormulario.vue?vue&type=template&id=82db0c60"
import script from "./MetodoFormulario.vue?vue&type=script&lang=js"
export * from "./MetodoFormulario.vue?vue&type=script&lang=js"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__